module.exports = __webpack_public_path__ + "static/img/industry_petrochemical.8989315.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/industry_petrochemical.jpg
// module id = scUB
// module chunks = 0